// Shamsi (Jalali) date utilities - Afghan month names, English numerals
const MONTHS_AF = ['حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس', 'جدی', 'دلو', 'حوت'];
const DAYS = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'];

// Gregorian to Jalali conversion
export function toJalali(gy, gm, gd) {
  let g_d_no, j_d_no, j_np, i;
  let g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

  gy -= 1600; gm -= 1; gd -= 1;
  g_d_no = 365 * gy + Math.floor((gy + 3) / 4) - Math.floor((gy + 99) / 100) + Math.floor((gy + 399) / 400);
  for (i = 0; i < gm; ++i) g_d_no += g_days_in_month[i];
  if (gm > 1 && ((gy + 1600) % 4 === 0 && ((gy + 1600) % 100 !== 0 || (gy + 1600) % 400 === 0))) ++g_d_no;
  g_d_no += gd;

  j_d_no = g_d_no - 79;
  j_np = Math.floor(j_d_no / 12053); j_d_no %= 12053;
  let jy = 979 + 33 * j_np + 4 * Math.floor(j_d_no / 1461);
  j_d_no %= 1461;
  if (j_d_no >= 366) { jy += Math.floor((j_d_no - 1) / 365); j_d_no = (j_d_no - 1) % 365; }
  for (i = 0; i < 11 && j_d_no >= j_days_in_month[i]; ++i) j_d_no -= j_days_in_month[i];
  let jm = i + 1; let jd = j_d_no + 1;
  return [jy, jm, jd];
}

// Force English (Latin) digits
function toEnDigits(str) {
  return String(str).replace(/[۰-۹]/g, d => String.fromCharCode(d.charCodeAt(0) - 1728))
                    .replace(/[٠-٩]/g, d => String.fromCharCode(d.charCodeAt(0) - 1584));
}

export function toShamsi(date) {
  if (!date) return '---';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '---';
  const [jy, jm, jd] = toJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
  return toEnDigits(`${jy}/${String(jm).padStart(2,'0')}/${String(jd).padStart(2,'0')}`);
}

export function toShamsiLong(date) {
  if (!date) return '---';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '---';
  const [jy, jm, jd] = toJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
  return toEnDigits(`${jd} ${MONTHS_AF[jm - 1]} ${jy}`);
}

export function toShamsiWithDay(date) {
  if (!date) return '---';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '---';
  const [jy, jm, jd] = toJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
  const dayName = DAYS[d.getDay()];
  return toEnDigits(`${dayName}، ${jd} ${MONTHS_AF[jm - 1]} ${jy}`);
}

export function todayShamsi() {
  return toShamsiLong(new Date());
}

export function isToday(date) {
  const d = new Date(date);
  const today = new Date();
  return d.toDateString() === today.toDateString();
}

export function isPast(date) {
  return new Date(date) < new Date();
}

export function daysUntil(date) {
  const diff = new Date(date) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function formatCurrency(amount) {
  if (!amount && amount !== 0) return '---';
  // Use en-US for English digits, then append Afghani symbol
  return new Intl.NumberFormat('en-US').format(amount) + ' ؋';
}

export function formatNumber(num) {
  if (!num && num !== 0) return '0';
  return new Intl.NumberFormat('en-US').format(num);
}

// تبدیل شمسی به میلادی برای ذخیره در دیتابیس
export function shamsiToGregorian(shamsiDate) {
  if (!shamsiDate) return '';
  const parts = shamsiDate.split('/');
  if (parts.length !== 3) return '';
  
  const jy = parseInt(parts[0]);
  const jm = parseInt(parts[1]);
  const jd = parseInt(parts[2]);
  
  // تبدیل جلالی به میلادی (فرمول ساده)
  const j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
  let jy2 = jy - 979;
  let jm2 = jm - 1;
  let jd2 = jd - 1;
  
  let g_days_no = 365 * jy2 + Math.floor(jy2 / 33) * 8 + Math.floor((jy2 % 33 + 3) / 4);
  for (let i = 0; i < jm2; ++i) g_days_no += j_days_in_month[i];
  g_days_no += jd2;
  
  let g_days_no2 = g_days_no + 79;
  let gy = 1600 + 400 * Math.floor(g_days_no2 / 146097);
  g_days_no2 %= 146097;
  
  let leap = true;
  if (g_days_no2 >= 36525) {
    g_days_no2--;
    gy += 100 * Math.floor(g_days_no2 / 36524);
    g_days_no2 %= 36524;
    if (g_days_no2 >= 365) {
      g_days_no2++;
    } else {
      leap = false;
    }
  }
  
  gy += 4 * Math.floor(g_days_no2 / 1461);
  g_days_no2 %= 1461;
  
  if (g_days_no2 >= 366) {
    leap = true;
    g_days_no2--;
    gy += Math.floor(g_days_no2 / 365);
    g_days_no2 %= 365;
  } else {
    leap = false;
  }
  
  const g_days_in_month = [31, (leap ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let gm = 0;
  for (let i = 0; i < 12 && g_days_no2 >= g_days_in_month[i]; ++i) {
    g_days_no2 -= g_days_in_month[i];
    gm++;
  }
  
  const gd = g_days_no2 + 1;
  return `${gy}-${String(gm+1).padStart(2, '0')}-${String(gd).padStart(2, '0')}`;
}

// تبدیل تاریخ میلادی به شمسی برای نمایش در input
export function toShamsiInput(date) {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const [jy, jm, jd] = toJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
  return `${jy}/${String(jm).padStart(2, '0')}/${String(jd).padStart(2, '0')}`;
}
